import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const groupByDomain = (ishodi) =>
  ishodi.reduce((acc, i) => {
    (acc[i.domain] = acc[i.domain] || []).push(i);
    return acc;
  }, {});

const codeSlug = (code) =>
  code.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const OutcomeCard = ({ item, selected, onSelect }) => (
  <button
    type="button"
    onClick={onSelect}
    aria-pressed={selected}
    data-testid={`ishod-${codeSlug(item.code)}`}
    className={cn(
      "group flex items-start gap-3 rounded-xl px-4 py-3 text-left transition-colors border",
      selected
        ? "bg-blue-50 border-blue-500 ring-1 ring-blue-500"
        : "bg-white border-slate-200 hover:bg-slate-50 hover:border-slate-300"
    )}
  >
    <span
      className={cn(
        "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border",
        selected ? "bg-blue-500 border-blue-500 text-white" : "border-slate-300 text-transparent"
      )}
    >
      <Check className="h-3 w-3" strokeWidth={3} />
    </span>
    <span className="space-y-0.5">
      <span className="flex items-center gap-2 text-xs font-semibold tracking-wide text-slate-400">
        {item.code}
        {item.samo_pracenje && (
          <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-medium text-amber-700">samo se prati</span>
        )}
      </span>
      <span className={cn("block text-sm leading-snug", selected ? "text-blue-800" : "text-slate-700")}>
        {item.ishod}
      </span>
    </span>
  </button>
);

export const OutcomePicker = ({ ishodi, selectedCode, onSelect }) => (
  <div className="space-y-6" data-testid="outcome-picker">
    {Object.entries(groupByDomain(ishodi)).map(([domain, items]) => (
      <div key={domain} className="space-y-2.5">
        <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500">{domain}</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5">
          {items.map((item) => (
            <OutcomeCard
              key={item.code}
              item={item}
              selected={selectedCode === item.code}
              onSelect={() => onSelect(item.code)}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default OutcomePicker;
